<template>
  <div class="time">
    <v-timeList
      :yearList="yearList"
      :articleCount="articleCount"
      :currentPage="currentPage"
      :pageNum="pageNum"
      :isLoading="isLoading"
    ></v-timeList>
    <v-sidebar
      @getColumnArticle="getColumnArticle"
      @toTag="toTag"
      :categories="categories"
      :tags="tags"
      :nowCategorie="nowCategorie"
      :nowTagName="nowTagName"
    ></v-sidebar>
  </div>
</template>

<script>
import Sidebar from "@/components/common/sidebar/sidebar";
import TimeList from "@/components/time/timeList/timeList";
export default {
  data() {
    return {
      yearList: {}
    };
  },
  props: {
    articleList: {
      type: Array,
      default: () => []
    },
    articleCount: {
      type: Number,
      default: 0
    },
    currentPage: {
      type: Number,
      default: 1
    },
    pageNum: {
      type: Number,
      default: 10
    },
    isLoading: {
      type: Boolean,
      default: true
    },
    categories: {
      type: Array,
      default: () => []
    },
    nowCategorie: {
      type: String,
      default: ""
    },
    tags: {
      type: Array,
      default: () => []
    },
    nowTagName: {
      type: String,
      default: ""
    }
  },
  components: {
    "v-sidebar": Sidebar,
    "v-timeList": TimeList
  },
  watch: {
    articleList(newVal) {
      this.filterYear();
    }
  },
  created() {},
  methods: {
    getColumnArticle(col) {
      this.$emit("getColumnArticle", col);
    },
    toTag(itemTag) {
      this.$emit("getTagArticle", itemTag);
    },
    filterYear() {
      let yearList = {};
      this.articleList.forEach(function(item) {
        var year = item.date.substring(0, 4);
        if (yearList["year" + year] === undefined) {
          yearList["year" + year] = [];
        }
        yearList["year" + year].push(item);
      }, this);
      //对对象进行key的降序排序
      var newkey = Object.keys(yearList)
        .sort()
        .reverse();
      var newObj = {}; //创建一个新的对象，用于存放排好序的键值对
      for (var i = 0; i < newkey.length; i++) {
        newObj[newkey[i]] = yearList[newkey[i]];
      }
      this.yearList = newObj;
    }
  },
  mounted() {
    this.filterYear();
  }
};
</script>

<style lang="less" scoped>
.time {
  width: 1024px;
  margin: auto;
  .error-wrapper {
    width: 75%;
  }
}
@media (max-width: 1024px) {
  .time {
    width: 100%;
    margin: auto;
    .emptyBox {
      height: 0;
    }
    .error-wrapper {
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?2ede4bd2